import React from "react";
import "./Footer.css";


const Footer = () => {
  return (
    <footer>
      <p>
        © {new Date().getFullYear()} - Made in Juanmi
        <span className="corazon-late" role="img" aria-label="corazón">❤️</span>.
      </p>
    </footer>
  );
};

export default Footer;
